$(->
  # TODO: brittany@careerplug.com 10/3 - Potentially stale.  These selectors are not in the codebase, and I've checked for usage of this code on the settings page and in the create and edit district pages.

  $('#location_region_id').change(->
    $.ajax({
      url: '/manage/districts.json',
      data: { region_id: $(this).val() },
      dataType: 'json',
      success: (data, textStatus, jqXHR)->
        $('#location_district_id').html('')
        $.each(data, (index, value)->
          $('#location_district_id').append('<option value="' + value.id + '">' + value.name + '</option>')
        )
    })
  ).change()

  # TODO: Also potentially stale, see above 

  $('#district_user_ids, #region_user_ids').change(->
    if ($(this).val() == '')
      $('.new_user_wrapper').show()
    else
      $('.new_user_wrapper').hide()
  ).change()

)